import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// helper ที่ shadcn/ui ทุก component เรียกใช้
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
